<div class="spacing-top justify-content-between">
	<div data-testid="SUBSYS4_MECHAXISWK_BACK_BTN" class="wrapper-back" (click)="back()" (keypress)="back()">
		<span class="material-icons md-18 back">arrow_back</span>
		<span class="action">{{ cancelBtnLabel }}</span>
	</div>
	@if (isCloseVisible) {
	<span data-testid="SUBSYS4_MECHAXISWK_CANCEL_BTN" class="material-icons md-18 back me-4" (click)="cancel()"
		(keypress)="cancel()">close</span>
	}
</div>

<div class="main-step">
	<div class="box-menu-settings active">
		<div class="row-box">
			@if (stateDescription?.isWorkflowRunning == workflowEnum.insertMechanicalAxis) {
			<h4>{{ labels().MECHANICAL_AXIS_COMPONENT_TITLE_MA }}</h4>
			}
			@if (stateDescription?.isWorkflowRunning == workflowEnum.insertContralateral) {
			<h4>{{ labels().MECHANICAL_AXIS_COMPONENT_TITLE_CTRL }}</h4>
			}
		</div>
		<div class="row-box">
			<div class="box-suggestion">
				@if (stateDescription?.isWorkflowRunning == workflowEnum.insertMechanicalAxis) {
				<p>{{ labels().MECHANICAL_AXIS_COMPONENT_MESSAGE_MA }}</p>
				}
				@if (stateDescription?.isWorkflowRunning == workflowEnum.insertContralateral) {
				<p>{{ labels().MECHANICAL_AXIS_COMPONENT_MESSAGE_CTRL }}</p>
				}
			</div>
		</div>
		<div class="row-box wrapper-img-axis" style="justify-content: center">
			<div class="" [hidden]="!isImgVisible">
				<img [src]="helpImg" alt="" (load)='isImgVisible = true' style="height: 40rem;">
			</div>
		</div>
		<div class="row-box align-items-center">
			<span class="material-icons ms-0 me-2">sync</span>
			<span data-testid="SUBSYS4_MECHAXISWK_RESET_BTN" class="a-link" (click)="reset()" (keypress)="reset()">
				{{ labels().MECHANICAL_AXIS_COMPONENT_RESET_BTN }}
			</span>
		</div>
		<div class="bottom-margin"></div>
		<div class="container-btn-confirm">
			<div class="divider-box"></div>
			<div class="wrapper-btn-confirm">
				<button data-testid="SUBSYS4_MECHAXISWK_CONFIRM_BTN" type="button" class="btn btn-primary px-2"
					[disabled]="stateDescription?.isPointsPositioningRunning" (click)="save()">
					{{ labels().MECHANICAL_AXIS_COMPONENT_CONFIRM_BTN }}
				</button>
			</div>
		</div>
	</div>
</div>